import { MessageBar, MessageBarBody, MessageBarTitle } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";

const Error = () => {
    const { t } = useTranslation();
    
    return (
        <MessageBar intent='error'>
            <MessageBarBody>
                <MessageBarTitle>{t("general.error")}</MessageBarTitle>
                {t("passwords.errors.loadPassword")}
            </MessageBarBody>
        </MessageBar>
    );
};

export default Error;